import axios from "axios";
const API = axios.create({ baseURL: "https://nostalgiaishere.herokuapp.com" });

// localmachine
// const url = "http://localhost:5000";

// heroku
// const url = "https://nostalgiaishere.herokuapp.com";

API.interceptors.request.use((req) => {
	if (localStorage.getItem("profile")) {
		// client side its A for authorization
		req.headers.Authorization = `Bearer ${
			JSON.parse(localStorage.getItem("profile")).token
		}`;
	}
	return req;
});

export const fetchPosts = () => API.get("/posts");
export const createPost = (newPost) => API.post("/posts", newPost);
export const updatePost = (id, updatedPost) =>
	API.patch(`/posts/${id}`, updatedPost);
export const deletePost = (id) => API.delete(`/posts/${id}`);
export const likePost = (id) => API.patch(`/posts/${id}/likePost`);

export const signIn = (formData) => API.post("/user/signin", formData);
export const signUp = (formData) => API.post("/user/signup", formData);
